import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=0415962e&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=0415962e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0415962e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ItemCard: require('/home/bitrix/frontend/components/gallery/ItemCard.vue').default})
